export * from './custom-dialog-with-actions.component';
export * from './dialog.colors';
export * from './dialog.config';
export * from './dialog.translations';
export * from './dialog.type';
